"use strict";
exports.__esModule = true;
exports.SIZES = exports.COLORS = void 0;
exports.COLORS = {
    primary: "#efefef"
};
exports.SIZES = {
    normal: 12,
    xxl: 40
};
//# sourceMappingURL=tokens.js.map